import React, { Fragment, Component } from 'react';
import { Field } from 'redux-form-normalize-on-blur/index';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import './index.css';
import { eye, eyeslash } from 'common/svg/icons';
import { isRequired } from 'common/form-validators';

const renderField = ({
  input,
  meta: { dirty, touched, valid, error },
  className,
  helpText = null,
  validText = null,
  validateOnChange = false,
  validateInit = false,
  ...rest
}) => {
  // In some cases we want to show validation errors immediately after the field
  // has been changed (vs. on blur)
  // validateInit to validate right away
  const touchedOrDirty = validateInit
    ? true
    : validateOnChange
    ? dirty
    : touched;
  const classes = classnames(className, 'input--text', {
    'is-danger': touchedOrDirty && error,
  });
  // to avoid a warning A component is changing an uncontrolled input of type text to be controlled.
  // it appears when format/normalize try to control from undefined to string
  const { value } = input;

  // to avoid uncontrolled input warning, set the original value to empty string
  return (
    <Fragment>
      <input
        {...rest}
        {...input}
        value={value || ''}
        component="input"
        className={classes}
      />
      {touchedOrDirty && error && (
        <small className="text--error">{error}</small>
      )}
      {valid && validText && (
        <small className="text--primary">{validText}</small>
      )}
      {!validText && helpText && (
        <small className="text--primary">{helpText}</small>
      )}
    </Fragment>
  );
};

renderField.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  className: PropTypes.string,
  helpText: PropTypes.string,
  validText: PropTypes.string,
  validateOnChange: PropTypes.bool,
  validateInit: PropTypes.bool,
};

class Input extends Component {
  state = {
    passvisible: false,
  };

  handlePassField = () => {
    this.setState({ passvisible: !this.state.passvisible });
  };

  render() {
    const {
      component = renderField,
      type = 'text',
      preText,
      infoText,
      hintText,
      className,
      theme,
      title,
      validate,
      withButton,
      ...rest
    } = this.props;
    const ispass = type === 'password';
    const inputtype = ispass ? (this.state.passvisible ? 'text' : type) : type;
    const Eye = this.state.passvisible ? eyeslash : eye;
    const classes = classnames(
      className,
      theme && theme.map(css => `input--${css}`).join(' '),
      type === 'checkbox' ? 'checkbox' : 'input',
      ispass && 'input--icon'
    );

    return (
      <fieldset className={!theme || theme.indexOf('tight') < 0 ? 'field' : ''}>
        {title && (
          <label htmlFor={name} className="input__title">
            {title} {isRequired(validate) && ' *'}
            {hintText && <label className="input__hint">({hintText})</label>}
          </label>
        )}
        <div className={'input__wrapper'}>
          <Field
            {...rest}
            component={component}
            type={inputtype}
            id={this.props.name}
            className={classes}
            validate={validate}
          />
          {preText && (
            <small className={'input__unit input__unit--pre'}>{preText}</small>
          )}
          {infoText && (
            <small className={'input__unit input__unit--sub'}>{infoText}</small>
          )}
          {withButton && (
            <small className={'input__unit input__unit--with-button'}>
              {withButton}
            </small>
          )}
          {ispass && (
            <Eye
              width="16px"
              height="14px"
              onClick={this.handlePassField}
              role="button"
            />
          )}
        </div>
      </fieldset>
    );
  }
}

Input.propTypes = {
  component: PropTypes.func,
  infoText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  preText: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
  theme: PropTypes.array,
  name: PropTypes.string.isRequired,
  validate: PropTypes.arrayOf(PropTypes.func),
  format: PropTypes.func,
  withButton: PropTypes.oneOfType([PropTypes.bool, PropTypes.element]),
  hintText: PropTypes.string,
};

export default Input;



// WEBPACK FOOTER //
// ./src/common/components/Input/index.js